<template>
  <div>
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addTopicGoods">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        :data-source="table.data"
        row-key="id"
        style="width: 100%"
        :scroll="{ y: 'calc(100vh - 200px)' }"
        :pagination="false"
        :loading="table.loading"
      >
        <a-table-column
          title="图片">
          <template slot-scope="text, record">
            <a-avatar :src="record.goods.coverPath"/>
          </template>
        </a-table-column>
        <a-table-column
          data-index="goods.name"
          title="商品">
        </a-table-column>
        <a-table-column
          title="是否推荐">
          <template slot-scope="text, record">
            {{ record.isRecommend}}
          </template>
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION')||'操作'">
          <template slot-scope="text, record">
            <a-button type="link" @click="editTopicGoods(record.id)">{{ $t('EDIT') || '编辑' }}</a-button>
            <a-button type="link" @click="recommendGoods(record.id,record.goods.id)">推荐</a-button>
            <a-button type="link" @click="deleteTopicGoods(record.id)">{{ $t('DELETE') || '删除' }}</a-button>

<!--            <a-button type="link" v-if="table.sort.prop === 'sort'" @click="upGoods(topicId,record.id)">上移</a-button>-->
<!--            <a-button type="link" v-if="table.sort.prop === 'sort'" @click="downGoods(topicId,record.id)">下移</a-button>-->
          </template>
        </a-table-column>

      </a-table>
      <a-pagination
        class ="pagination-class"
        v-model="table.query.page"
        :total="table.query.total"
        show-size-changer
        :page-size="table.query.size"
        :pageSizeOptions="['20']"
        @showSizeChange="handleSizeChange"
        @change="handleSizeChange">
        <template
          slot="buildOptionText"
          slot-scope="props">
          <span>{{ props.value }}条/页</span>
        </template>
      </a-pagination>
    </div>
    <a-modal
      :footer="null"
      append-to-body
      :title="$t('PREVIEW')||'预览'"
      v-model="form.visible">
      <look-book-topic-goods-edit
        v-if="form.visible"
        :topic-id="topicId"
        :topic-goods-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm"
      />
    </a-modal>
  </div>
</template>

<script>
import {
  _queryTopicGoods,
  _upTopicGoods,
  _downTopicGoods,
  _recommendTopicGoods,
  _deleteTopicGoods,
} from '@/api/lookBookTopicGoodsApi';
import LookBookTopicGoodsEdit from '@/views/cms/lookBookTopic/LookBookTopicGoodsEdit.vue';

async function initData() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryTopicGoods({
    topicId: this.topicId,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.query.total = result.totalElements;
  this.table.loading = false;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.initData();
}

function handleSizeChange(page, size) {
  this.table.query.page = page;
  this.table.query.size = size;
  this.initData();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.initData();
}

function addTopicGoods() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editTopicGoods(id) {
  this.form.data.id = id;
  this.form.visible = true;
}

function deleteTopicGoods(id) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      await _deleteTopicGoods(id);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      this.initData();
    },
  });
}

async function upGoods(topicId, goodsId) {
  this.$confirm({
    title: '是否上移？',
    content: '',
    onOk: async () => {
      await _upTopicGoods(topicId, goodsId);
      this.$message.success('上移成功');
      this.initData();
    },
  });
}

async function downGoods(topicId, goodsId) {
  this.$confirm({
    title: '是否下移？',
    content: '',
    onOk: async () => {
      await _downTopicGoods(topicId, goodsId);
      this.$message.success('下移成功');
      this.initData();
    },
  });
}

async function recommendGoods(topicGoodsId, goodsId) {
  this.$confirm({
    title: '是否推荐？',
    content: '',
    onOk: async () => {
      await _recommendTopicGoods(topicGoodsId, goodsId);
      this.$message.success('推荐成功');
      this.initData();
    },
  });
}

export default {
  name: 'LookBookTopicItems',
  components: {
    LookBookTopicGoodsEdit
  },
  props: {
    topicId: String,
  },
  watch: {
    // topicGoodsId() {
    //   if (this.topicGoodsId) {
    //     this.initData();
    //   }
    // },
  },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        loading: false,
        data: [],
        query: {
          page: 1,
          size: 20,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    closeForm,
    handleSizeChange,
    handlePageChange,
    upGoods,
    downGoods,
    recommendGoods,
    initData,
    addTopicGoods,
    editTopicGoods,
    deleteTopicGoods,
  },
  created() {
    this.initData();
  },
};
</script>

<style scoped>

</style>
